import { List } from 'immutable'
import PropTypes from 'prop-types'
import React, { useCallback } from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { useDispatch } from 'react-redux'
import TileSubscription from '../../TileSubscription/index'
import { Tabs, Tab, TABS_JUSTIFY } from '../../Tabs/index'
import { requestAnimationFrame } from '../../../services/animate/index'
import Row, { STYLES } from '../../Row.v2/index'
import { setEventDefault } from '../../../services/event-tracking/actions'
import { CUSTOM_EVENT_GA4_EVENT } from '../../../services/event-tracking/index'

function createAccessor (Accessor, item) {
  if (!item) return null
  const url = item.get('url', '') || ''
  return (
    <Accessor
      className={url ? '' : 'no-follow'}
      title={item.get('title', '')}
      to={url}
    />
  )
}

function handleGaEvent (dispatch) {
  // GA4 event
  dispatch(setEventDefault(CUSTOM_EVENT_GA4_EVENT.mergeDeep({
    event_category: 'User Engagement',
    event_action: 'Carousel Click',
    event_label: 'followers-and-following',
  })))
}

function renderItem (item, dispatch) {
  return (
    <TileSubscription
      title={item.get('title')}
      hero={item.get('image')}
      onClick={() => handleGaEvent(dispatch)}
      url={item.get('url')}
    />
  )
}

function renderRow (items, auth, viewAllLabel, setMode, dispatch) {
  const tileItems = items.map((s) => s.get('tile'))
  return (
    <Row
      createAccessor={createAccessor}
      ctaLabel={viewAllLabel}
      style={STYLES.S23456}
      ctaOnClick={setMode}
      items={tileItems}
      auth={auth}
    >
      {(item) => renderItem(item, dispatch)}
    </Row>
  )
}

export default function Community (props) {
  const {
    staticText,
    setMode,
    portal,
    modes,
    auth,
  } = props
  const dispatch = useDispatch()
  const subscribersLabel = staticText.get('followers')
  const subscriptionsLabel = staticText.get('following')
  const subscribersCount = portal.getIn(['subscribers', 'count'], 0)
  const subscriptionsCount = portal.getIn(['subscriptions', 'count'], 0)
  const subscribers = portal.getIn(['subscribers', 'subscribers'], List())
  const subscriptions = portal.getIn(['subscriptions', 'subscriptions'], List())
  const subscribersViewAll = subscribersCount > 12 ? staticText.get('rowViewAll').replace('{totalItems}', subscribersCount) : ''
  const subscriptionsViewAll = subscriptionsCount > 12 ? staticText.get('rowViewAll').replace('{totalItems}', subscriptionsCount) : ''

  const setModeFollowers = useCallback(() => {
    setMode(modes.FOLLOWERS)
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }, [])

  const setModeFollowing = useCallback(() => {
    setMode(modes.FOLLOWING)
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }, [])

  if (subscribers.size === 0 && subscriptions.size === 0) {
    return null
  }

  const tabs = []

  if (subscribers.size > 0) {
    tabs.push(
      <Tab label={subscribersLabel} key={subscribersLabel}>
        {renderRow(subscribers, auth, subscribersViewAll, setModeFollowers, dispatch)}
      </Tab>,
    )
  }

  if (subscriptions.size > 0) {
    tabs.push(
      <Tab label={subscriptionsLabel} key={subscriptionsLabel}>
        {renderRow(subscriptions, auth, subscriptionsViewAll, setModeFollowing, dispatch)}
      </Tab>,
    )
  }

  return (
    <section className="portal-v2-community">
      <div className="portal-v2-community__divider-line" role="presentation" />
      <div className="portal-v2-community__tabs">
        <Tabs justify={TABS_JUSTIFY.LEFT} >
          {tabs}
        </Tabs>
      </div>
    </section>
  )
}

Community.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  portal: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  setMode: PropTypes.func.isRequired,
  modes: PropTypes.object.isRequired,
}
